var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-animate",rawName:"v-lazy-animate",value:(0.2),expression:"0.2"}],staticClass:"home"},[_c('Carousel'),_c('NewProduct'),_c('ReservationProcess'),_c('StandardService'),_c('ChoiceProduct')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }